import { render } from "./Satker.vue?vue&type=template&id=36944da2"
import script from "./Satker.vue?vue&type=script&lang=js"
export * from "./Satker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__